<script>
import Layout from "../../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { roleService } from "../../../../../services/settingservice/securityservice/role.service";
import List from "../../../../../components/list";
//import i18n from "../../../../../i18n";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  page: {
    title: "Role List",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, List },
  data() {
    return {
      roleDataList: {},
      fetchingStats: true
    };
  },
  mounted() {
    
    this.loadingData();
  },

  methods: {
    loadingData: function(param = '') {
      this.fetchingStats = false;
      roleService.getList(param)
        .then(response => {
          
          this.fetchingStats = true;
          this.roleDataList = response;

          console.log(this.roleDataList);
        });
    },
    deleted(id){
      this.fetchingStats = false;
      roleService.remove(id)
        .then(response => {
          console.log(response);
          this.fetchingStats = true;
          this.loadingData();
        });
    },
    pageNavigate: function(param) {
      this.loadingData(param);
    },
  }
};
</script>

<template>
  <Layout>
    <PageHeader :add="{icon: 'bx bx-add-to-queue bx-tada', title: 'general.new', link: 'role-add'}" :title="$t('setting.security.role.text')" />
    <List v-bind:dataList="roleDataList" 
          v-bind:updating="fetchingStats" 
          v-bind:navigate="pageNavigate"
          v-bind:formats="[{name: 'status', color: true}]"
          v-bind:fields="[ 
            `name: ${$t('setting.security.role.name')}`, 
            `name_en: ${$t('setting.security.role.name-en')}`, 
            `status: ${$t('setting.security.role.full-permission')}`, 
          ]"
          v-bind:deletes="[deleted, null]"
          v-bind:edit="{link: 'role-edit'}"
          v-bind:filter="{
            search: ['roles.name', 'roles.name_en'],
            dropdown: []
          }"
          
    />     
  </Layout>
</template>